import Modal from '@scripts/modules/Modal.js';

const 
  MESSAGE_IMPORTANCE_HIGH = true;


class MessageModal extends Modal{

  constructor() {
      super();
      this.modal = document.getElementById("message-modal");
      this.messageItem = this.modal.querySelector('.message-modal__message');
  }

  showMessage(message, highImportance = false) {

    (highImportance) ?
      this.messageItem.classList.add('message-modal__message--important') :
      this.messageItem.classList.remove('message-modal__message--important');

    this.messageItem.textContent = message;
    super.openModal(this.modal);
  }

}

const messageModal = new MessageModal();
messageModal.MESSAGE_IMPORTANCE_HIGH = MESSAGE_IMPORTANCE_HIGH;

export default messageModal;